import { propsFactory } from '@components/utils';

import type { ExtractPropTypes, PropType } from 'vue';
import type { NTree } from '@components/components';

export const makeTreeNodeProps = propsFactory(
  {
    eventKey: {
      type: [String, Number] as PropType<NTree.TKey>,
      default: ''
    },
    prefixCls: String,

    title: [Function, String],
    data: { type: Object as PropType<NTree.IDataNode>, default: undefined as unknown as NTree.IDataNode },
    parent: { type: Object as PropType<NTree.IDataNode>, default: undefined as unknown as NTree.IDataNode },

    isStart: { type: Array as PropType<boolean[]> },
    isEnd: { type: Array as PropType<boolean[]> },
    active: { type: Boolean, default: undefined },
    onMousemove: { type: Function as PropType<NTree.TEventHandler> },

    // By user
    isLeaf: { type: Boolean, default: undefined },
    checkable: { type: Boolean, default: undefined },
    selectable: { type: Boolean, default: undefined },
    disabled: { type: Boolean, default: undefined },
    disableCheckbox: { type: Boolean, default: undefined },
    icon: [Function],
    switcherIcon: [Function],
    domRef: { type: Function as PropType<(arg: any) => void> }
  },
  'tree-node'
);

export type ITreeNodeProps = Partial<ExtractPropTypes<ReturnType<typeof makeTreeNodeProps>>>;
